export const ACTIONS_COLUMN_ID = 'actions';
export const SELECTION_COLUMN_ID = 'selection';
export const GRID_ROW_ERROR_CLASSNAME = 'gridRowError';
